// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Styles from "../../styles/components/Styles.bs.jsx";
import * as Stdlib_Dict from "@rescript/runtime/lib/es6/Stdlib_Dict.js";
import * as InputWrapper from "../InputWrapper/InputWrapper.bs.jsx";
import * as Stdlib_Array from "@rescript/runtime/lib/es6/Stdlib_Array.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as FormattedCurrency from "../FormattedCurrency/FormattedCurrency.bs.jsx";
import * as JsxRuntime from "react/jsx-runtime";
import InputDonorsModuleCss from "./InputDonors.module.css";

let classes = InputDonorsModuleCss;

function InputDonors(props) {
  let onChange = props.onChange;
  let value = props.value;
  let persons = props.persons;
  let legendSlot = props.legendSlot;
  let errorMessage = props.errorMessage;
  let match = FormattedCurrency.useCurrency();
  let minorUnit = match.minorUnit;
  let match$1 = React.useMemo(() => {
    let entries = Object.entries(value);
    let unused = Array.from(persons.entries()).filter(param => value[param[0]] === undefined);
    let sum = Stdlib_Array.reduce(entries, 0, (acc, param) => acc + param[1] | 0);
    return [
      entries,
      unused,
      sum
    ];
  }, [value]);
  let unusedPersons = match$1[1];
  return <fieldset
    className={`reset ` + classes.root}
  >
    {legendSlot !== undefined ? <legend>
        {legendSlot}
      </legend> : null}
    <table>
      <thead>
        <tr>
          <th
            scope={"col"}
          >
            {"Jméno"}
          </th>
          <th
            scope={"col"}
          >
            {"Částka"}
          </th>
          <th
            scope={"col"}
          >
            <span
              className={Styles.utility.srOnly}
            >
              {"Akce"}
            </span>
          </th>
        </tr>
      </thead>
      <tbody>
        {match$1[0].map(param => {
          let personId = param[0];
          return <tr
            key={personId} >
            <th
              scope={"row"}
            >
              {Stdlib_Option.getOrThrow(persons.get(personId), undefined)}
            </th>
            <td>
              <input
                min={"0"}
                step={1}
                type={"number"}
                value={(param[1] / minorUnit).toString()}
                onChange={e => {
                  let target = e.target;
                  let newAmount = target.valueAsNumber;
                  let newAmountInt = newAmount * minorUnit | 0;
                  let newValue = Object.assign({}, value);
                  newValue[personId] = newAmountInt;
                  onChange(newValue);
                }}
              />
            </td>
            <td>
              <button
                className={Styles.button.iconOnly + ` ` + Styles.button.sizeExtraSmall}
                title={"Odebrat vkladatele"}
                type={"button"}
                onClick={param => {
                  let newValue = Object.assign({}, value);
                  Stdlib_Dict.$$delete(newValue, personId);
                  onChange(newValue);
                }}
              >
                {"❌"}
              </button>
            </td>
          </tr>;
        })}
      </tbody>
      <tbody>
        <tr>
          <td
            colSpan={2}
          >
            <select
              disabled={unusedPersons.length === 0}
              value={""}
              onChange={event => {
                let person = event.target.value;
                if (person === "") {
                  return;
                }
                let newValue = Object.assign({}, value);
                newValue[person] = 0;
                onChange(newValue);
              }}
            >
              <option
                disabled={true}
                value={""}
              >
                {"Přidat vkladatele"}
              </option>
              {unusedPersons.map(param => {
                let personId = param[0];
                return <option
                  key={personId} 
                  value={personId}
                >
                  {param[1]}
                </option>;
              })}
            </select>
          </td>
        </tr>
      </tbody>
      <tfoot>
        <tr>
          <th
            scope={"row"}
          >
            {"Celkem"}
          </th>
          <td
            colSpan={2}
          >
            <FormattedCurrency.make
              value={match$1[2]}
            />
          </td>
        </tr>
      </tfoot>
    </table>
    {errorMessage !== undefined ? <InputWrapper.ErrorMessage.make
        message={errorMessage}
      /> : null}
  </fieldset>;
}

let make = InputDonors;

export {
  classes,
  make,
}
/* classes Not a pure module */
